<span
  class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide"
  [ngClass]="{'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': type === 'warn',
  'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50': type === 'success',
  'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50': type === 'alert',
  'bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50': type === 'info'}"
  [matTooltip]="tooltip"
  [matTooltipPosition]="tooltipPosition">

  <span class="leading-relaxed whitespace-nowrap">{{text}}</span></span>
